import { useCallback, useEffect, useRef, useState } from 'react';
import { onBackgroundAudioUnlock } from '../systems/media-utils';

const MUSIC_SRC = '/music.mp3';

export function useBackgroundMusic() {
  const audioRef = useRef<HTMLAudioElement | null>(null);
  const enabledRef = useRef(true);
  const [enabled, setEnabled] = useState(true);

  useEffect(() => {
    const audio = new Audio(MUSIC_SRC);
    audio.loop = true;
    audioRef.current = audio;
    void audio.play().catch(() => {});

    const unsubscribe = onBackgroundAudioUnlock(() => {
      if (enabledRef.current) void audio.play().catch(() => {});
    });

    return () => {
      unsubscribe();
      audio.pause();
      audioRef.current = null;
    };
  }, []);

  const toggle = useCallback(() => {
    setEnabled((prev) => {
      const next = !prev;
      enabledRef.current = next;
      const audio = audioRef.current;
      if (!audio) return next;
      if (next) void audio.play().catch(() => {});
      else audio.pause();
      return next;
    });
  }, []);

  const resume = useCallback(() => {
    if (!enabledRef.current) return;
    void audioRef.current?.play().catch(() => {});
  }, []);

  return { enabled, toggle, resume };
}
